
import { useState, useEffect } from 'react';
import { Event } from '@/lib/types';
import { fetchAllPublicEvents } from '@/services/eventService';

export function useEventLoading(token: string | null) {
  const [allEvents, setAllEvents] = useState<Event[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // Always load live data from API (removed mock data condition per user request)
    const loadEvents = async () => {
      setIsLoading(true);
      try {
        console.log('🔄 Loading events from API...');
        const events = await fetchAllPublicEvents();
        console.log('✅ Events loaded:', events.length, 'events');
        console.log('📋 First few events:', events.slice(0, 3));
        setAllEvents(events);
        setError(null);
      } catch (error) {
        console.error('❌ Failed to fetch events:', error);
        setError(error instanceof Error ? error : new Error('Failed to fetch events'));
      } finally {
        setIsLoading(false);
      }
    };

    loadEvents();
  }, [token]); // Only depend on token since we're fetching all public events

  // Find event helper function
  const findEventBySlugOrCode = (slugOrCode: string): Event | undefined => {
    if (!slugOrCode || allEvents.length === 0) return undefined;

    return allEvents.find(e =>
      (e.slug && e.slug === slugOrCode) ||
      (e.code && e.code === slugOrCode) ||
      // Also check for SEO-friendly URLs that might contain the event name
      (e.slug && slugOrCode.startsWith(e.slug + '-'))
    );
  };

  return {
    allEvents,
    isLoading,
    error,
    findEventBySlugOrCode
  };
}
